/** Shared page header typography for list / add-edit screens. */
export const pageTitleSx = {
  fontSize: 20,
  fontWeight: 600,
} as const;

export const pageTitleSxResponsive = (isMobile: boolean) => ({
  fontSize: isMobile ? 18 : 20,
  fontWeight: 600,
});

export const pageSubtitleSx = {
  mt: 0,
  mb: 0,
  fontSize: '0.8125rem',
  color: 'text.secondary',
} as const;
